import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useEffect } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import "./CustomAnswerSheet.css";
import { useMediaQuery } from "react-responsive";

const CustomAnswerSheet = ({ open, setOpenBottomSheet, yomiHuda }) => {
    useEffect(() => {
        console.log(open);
    }, [open]);
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    return (
        <div className="answer-sheet" style={{width:"50% !important"}}>
            <div
                className="answer-sheet"
                onClick={() => {
                    console.log("CustomAnswerSheet Clicked");
                }}
            >
                <BottomSheet
                    className="answer-sheet"
                    style={{width:"50%" }}
                    open={open}
                    snapPoints={({ minHeight, maxHeight }) => [
                        maxHeight * 9, //최대
                    ]}
                    onDismiss={() => {
                        setOpenBottomSheet(false);
                    }}
                    onClick={()=>{
                        setOpenBottomSheet(false);
                    }}
                >
                    <div>
                        <div style={{ display: "flex",marginLeft:"1rem" }}>
                            <IconButton
                                onClick={() => {
                                    setOpenBottomSheet(false);
                                }}
                            >
                                <CloseIcon className="home-button"></CloseIcon>
                            </IconButton>
                        </div>
                        <div style={{ display: "flex" }}>
                            <img
                                style={{
                                    width: isWide?"60%":"95%",
                                    position: "absolute",
                                    left: "50%",
                                    top: "50%",
                                    transform: "translate(-50%,-50%)",
                                }}
                                className="answer-image"
                                src={yomiHuda}
                                loading="eager"
                                // style={{ height: "inherit", width: "100%" }}
                                alt="今、プレイされる札のイメージ"
                            />
                        </div>
                    </div>
                    {/* <PlayItem eHuda={customHudaList[0].eHuda} setOpenBottomSheet={setOpenBottomSheet}></PlayItem>
                    <PlayItem eHuda={customHudaList[1].eHuda} setOpenBottomSheet={setOpenBottomSheet}></PlayItem> */}
                </BottomSheet>
            </div>
        </div>
    );
};

export default CustomAnswerSheet;
